import {
  GET_EVENT_ATTRIBUTES_FAILURE,
  GET_EVENT_ATTRIBUTES_REQUEST,
  GET_EVENT_ATTRIBUTES_SUCCESS,
  GetEventAttributesFailureAction,
  GetEventAttributesRequestAction,
  GetEventAttributesSuccessAction,
} from './eventAttributes.types';
import { EventAttribute } from '../../services/eventAttributesService/eventAttributesService';

export const getEventAttributesRequest = (
  eventName: string
): GetEventAttributesRequestAction => ({
  type: GET_EVENT_ATTRIBUTES_REQUEST,
  payload: eventName,
});

export const getEventAttributesSuccess = (
  payload: EventAttribute
): GetEventAttributesSuccessAction => ({
  type: GET_EVENT_ATTRIBUTES_SUCCESS,
  payload,
});

export const getEventAttributesFailure = (
  error: string
): GetEventAttributesFailureAction => ({
  type: GET_EVENT_ATTRIBUTES_FAILURE,
  payload: error,
});
